module.exports = __webpack_public_path__ + "static/media/empretec-1.724df7cc.jpg";